export const ANALYTICS_CONSENT_STATE = {
  UNKNOWN: "unknown",
  GRANTED: "granted",
  DENIED: "denied",
};

export const ANALYTICS_CONSENT_STORAGE_KEY = "tssh_analytics_consent";
export const ANALYTICS_CONSENT_CHANGE_EVENT = "tssh:analytics-consent-change";
export const ANALYTICS_CONSENT_OPEN_EVENT = "tssh:analytics-consent-open";

function canUseBrowserApis() {
  return typeof window !== "undefined" && typeof localStorage !== "undefined";
}

function dispatchConsentEvent(eventName, detail = {}) {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new CustomEvent(eventName, { detail }));
}

function getGoogleConsentModeState(state) {
  return {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: state === ANALYTICS_CONSENT_STATE.GRANTED ? "granted" : "denied",
  };
}

export function updateGoogleConsentMode(state) {
  if (typeof window === "undefined") {
    return;
  }

  window.dataLayer = window.dataLayer || [];

  if (typeof window.gtag !== "function") {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  window.gtag("consent", "update", getGoogleConsentModeState(state));
}

export function getAnalyticsConsentState() {
  if (!canUseBrowserApis()) {
    return ANALYTICS_CONSENT_STATE.UNKNOWN;
  }

  const storedValue = localStorage.getItem(ANALYTICS_CONSENT_STORAGE_KEY);

  if (storedValue === ANALYTICS_CONSENT_STATE.GRANTED || storedValue === ANALYTICS_CONSENT_STATE.DENIED) {
    return storedValue;
  }

  return ANALYTICS_CONSENT_STATE.UNKNOWN;
}

export function hasAnalyticsConsent() {
  return getAnalyticsConsentState() === ANALYTICS_CONSENT_STATE.GRANTED;
}

export function setAnalyticsConsentState(state) {
  if (!canUseBrowserApis()) {
    return;
  }

  localStorage.setItem(ANALYTICS_CONSENT_STORAGE_KEY, state);
  updateGoogleConsentMode(state);
  dispatchConsentEvent(ANALYTICS_CONSENT_CHANGE_EVENT, { state });
}

export function clearAnalyticsConsentState() {
  if (!canUseBrowserApis()) {
    return;
  }

  localStorage.removeItem(ANALYTICS_CONSENT_STORAGE_KEY);
  updateGoogleConsentMode(ANALYTICS_CONSENT_STATE.UNKNOWN);
  dispatchConsentEvent(ANALYTICS_CONSENT_CHANGE_EVENT, {
    state: ANALYTICS_CONSENT_STATE.UNKNOWN,
  });
}

export function openAnalyticsConsentPreferences() {
  dispatchConsentEvent(ANALYTICS_CONSENT_OPEN_EVENT);
}
